import { personalDailyDealsEndpoints } from "./personal-daily-deals.api"

export const { useGetListQuery, useGetActiveDealsQuery, useSpinWhealMutation } =
  personalDailyDealsEndpoints
